module.exports = __webpack_public_path__ + "img/aesthetic_medical_clinic.af97843d.webp";